/* sugar:assets/password-modal.js@2.0.0 */
/* Password page: the enter-password dialog. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.passwordReady) return;
    root.dataset.passwordReady = '1';

    var dialog = root.querySelector('[data-password-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var openButton = root.querySelector('[data-password-open]');
    var closeButton = dialog.querySelector('[data-password-close]');

    function show() {
      if (dialog.open) return;
      dialog.showModal();
      var input = dialog.querySelector('input[type="password"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }

    function hide() {
      if (dialog.open) dialog.close();
    }

    if (openButton) openButton.addEventListener('click', show);
    if (closeButton) closeButton.addEventListener('click', hide);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) hide();
    });

    if (dialog.querySelector('input[aria-invalid="true"]')) show();

  }

  function boot() {
    document.querySelectorAll('[data-password-header]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-password-header]');
    if (root) init(root);
  });
})();
